// eslint-disable-next-line no-restricted-imports -- This is the canonical source for storage factories
import { createLocalStorage, createSessionStorage } from '@macfja/svelte-persistent-store';

// Impersonation tabs use session storage so per-user data (classes,
// subscriptions, etc.) stays isolated to the tab and doesn't overwrite
// the admin's localStorage data.
function _isImpersonationTab() {
    /* istanbul ignore next -- SSR guard, never true in browser tests */
    if (typeof window === 'undefined') return false;
    try {
        if (new URL(window.location.href).searchParams.has('impersonate')) return true;
        // @macfja/svelte-persistent-store uses JSON serialization, so
        // null is stored as the string 'null' and 'active' as '"active"'.
        const ghost = sessionStorage.getItem('ghostToken');
        return ghost !== null && ghost !== 'null';
    } catch { return false; }
}

/** true when running in an impersonation tab */
export const isImpersonationTab = _isImpersonationTab();

/** Returns sessionStorage for impersonation tabs, localStorage otherwise. */
export const createUserStorage = isImpersonationTab ? createSessionStorage : createLocalStorage;
